<template>
  <div>
    <statistik :value="statistik"></statistik>
    <v-card tile flat class="mb-10">
      <v-card-text>
        <list-sekolah ref="sekolah" @verval="onVerval" @batal="onBatalVerval" />
      </v-card-text>
    </v-card>
    <base-modal-full
      generalError
      :autoClose="false"
      ref="modal"
      title="Verval Data Kepala Sekolah"
      @save="onVervalSave"
      @close="onVervalClose"
    >
      <form-verval ref="formulir" :kandidat="kandidat" :validasi="validasi" />
    </base-modal-full>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import list from '@mixins/list';
import Statistik from '../base/Statistik';
import ListSekolah from './List';
import FormVerval from './form/Verval';
export default {
  name: 'verval-index',
  mixins: [list],
  components: { Statistik, ListSekolah, FormVerval },
  data() {
    return {
      kJenjang: '',
      validasi: '',
      kandidat: {},
      statistik: {},
    };
  },

  ...mapState('peringkat', {
    pspPeringkat: (state) => state.psp_peringkat,
  }),

  created() {
    this.getStatistik();
  },

  methods: {
    ...mapActions('peringkat', ['detail', 'save']),

    async getStatistik() {
      const { data } = await this.detail({ action: 'kandidat', id: 'statistik' });
      this.statistik = data;
    },

    async onVerval(kandidat) {
      const action = 'kandidat';
      const id = kandidat.psp_peringkat_kandidat_id;
      const { data, validasi } = await this.detail({ action, id });

      this.kandidat = data;
      this.validasi = validasi;

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
      });
    },

    onBatalVerval(kandidat) {
      const msg = [
        '<span class="body-2 black--text">Apakah Anda yakin ingin membatalkan verval peserta berikut?</span>',
        `<p class="black--text"><strong>Nama: </strong>${kandidat.nama}<br /><strong>SIMPKB ID: </strong>${kandidat.ptk_id_kasek}</p>`,
      ].join('');

      this.$confirm(msg, 'Konfirmasi Batal Verval').then(() => {
        this.save({ action: 'kandidat', type: 'batal-verval', id: kandidat.psp_peringkat_kandidat_id }).then(() => {
          this.$success('Berhasil dibatalkan');
          this.onReload();
          this.$emit('reload');
        });
      });
    },

    onVervalSave() {
      const action = 'kandidat';
      const type = 'verval';
      const id = this.kandidat.psp_peringkat_kandidat_id;
      const values = this.$refs.formulir.getValue();
      const params = new FormData();
      let error = '';

      if (!values.k_verval_peringkat_psp) {
        error = 'Hasil seleksi verval belum dipilih';
      }

      if (+values.k_verval_peringkat_psp === 3) {
        if (!values.catatan_verval) {
          error = 'Alasan diskulafikasi belum dipilih';
        } else if (values.catatan_verval === 'Alasan lainnya' && !values.catatan_verval_lain) {
          error = 'Alasan diskualifikasi lainnya belum diisikan';
        }
      }

      if (error) {
        this.$error(error);
        this.$refs.modal.loading = false;
        return;
      }

      params.append('k_verval_peringkat_psp', values.k_verval_peringkat_psp);
      if (values.k_verval_peringkat_psp === 3) {
        params.append('file', values.file);
        if (values.catatan_verval_lain) {
          params.append('catatan_verval', values.catatan_verval_lain);
        } else {
          params.append('catatan_verval', values.catatan_verval);
        }
      } else if (values.k_verval_peringkat_psp === 4) {
        params.append('catatan_verval', values.catatan_verval_lain);
      }

      this.save({ params, action, type, id, upload: true })
        .then(() => {
          this.$success('Data berhasil disimpan');
          this.$refs.modal.dialog = false;
          this.onReload();
          this.$emit('reload');
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onVervalClose() {
      this.$confirm('Anda yakin ingin keluar dari halaman ini ?', 'Konfirmasi').then(() => {
        this.$refs.modal.dialog = false;
      });
    },

    onReload() {
      this.getStatistik();
      this.$refs.sekolah.onReload();
    },
  },
};
</script>

<style scoped></style>
